export default {
    education: {
        common: {
            approveState: {
                '1': 'Требуется согласование',
                '2': 'В процессе согласования',
                '3': 'Согласовано',
                '4': 'Отклонено',
                '5': 'Согласование не требуется'
            },
            substate: 'Подстостояние'
        },
        actionVacancy: {
            headers: {
                type: 'Тип',
                state: 'Статус',
                responsible: 'Ответственный',
            },
            types: {
                request: 'Запрос',
                active: 'Опубликованные',
                archive: 'Архивные',
            },
            card: {
                annotation: 'Аннотация',
                authors: 'Авторы',
                duration: 'Предполагаемая длительность',
                exam: 'Тип экзамена',
                requirments: 'Требования к участникам',
                cost: 'Стоимость',
                costPerPeople: 'Стоимость на человека',
                comment: 'Комментарий автора',
                goals: 'Цели',
                tasks: 'Задачи',
                additionalResources: 'Дополнительные ресурсы',
                schedule: 'Предполагаемое расписание',
                trainer: 'Предполагаемые тренеры',
                date: 'Дата',

                publication: 'Дата публикации',
                done: 'Дата завершения',
                libraryObjects: 'Библиотечные объекты'
            },
            state: {
                planning: 'Планирование мероприятия (Обучение)',
                gathering: 'Оценка потребностей',
                event: 'Запись на мероприятие (Обучение)',
                registration: 'Запись на мероприятие',
                '7': 'Запись на мероприятие (Оценка)',
                '8': 'Планирование мероприятия (Оценка)',
            },
        },
        application: {
            create: 'Создать заявку',
            edit: 'Редактировать заявку',
            send: 'Отправить',
            title: 'Заявка',
            headers: {
                vacancy: 'Мероприятие',
                sender: 'Отправитель',
                datetime: 'Время',
            },
        },
        action: {
            headers: {
                project: 'Мероприятие',
                stage: 'Стадия',
            },
            participants: 'Участники',
            stages: 'Сценарий',
        },
        approvalApplication: {
            headers: {
                people: 'ФИО',
                vacancy: 'Название курса',
            }
        },
        event: {
            name: 'Название',
            toPersonTimetable: 'Перейти к расписанию'
        },
        courses: {
            headers: {
                name: 'Название курса',
                isIndividual: 'Индивидуальный курс',
                needApproval: 'Требуется согласование'
            },
            annotation: 'Аннотация',
            createData: 'Дата создания',
            authors: 'Авторы',
            duration: 'Предполагаемая продолжительность',
            examType: 'Тип экзамена',
            requirments: 'Требования к участникам',
            cost: 'Общая стоимость',
            costPerPerson: 'Стоимость на человека',
            comment: 'Комментарий автора',
            goals: 'Цели',
            tasks: 'Задачи',
            resources: 'Дополнительные ресурсы',
            schedule: 'Предполагаемое расписание',
            trainer: 'Предпологаемые тренеры',
            valuta: 'Валюта',
            stageList: 'Этапы',
            scenName: 'Название сценария',
            type: 'Тип',
            typeNumber: {
                1: 'Дистанционное обучение',
                4: 'Дистанционная оценка'
            },
            enroll: 'Записаться',
            enrollSuccess: 'Успешно записан'
        },
        scenario: {
            name: '%(name)s',
            object: 'Тема сценария',
            responsible: 'Ответственный',
            person: 'Человек',
            sender: 'Отправитель',
            send: 'Отправлено',
            scen: 'Имя сценария',
            stageName: 'Название этапа',
            tests: 'Тесты',
            stages: 'Этапы',
            states: 'Состояние',
            test: 'Тест',
            scormTest: 'SCORM - Тест',
            type: 'Тип',
            book: 'Книга',
            doc: 'Документ',
            training: 'Обучение',
            toScenario: 'Перейти к сценарию',
            forNextStage: 'Для того чтобы перейти на след. этап, нужно закрыть все тесты и отметить все книги как прочитанные',
            state: {
                '3': 'Открыт',
                '7': 'Пройден',
                '8': 'Аннулирован',
                '0': 'Не доступен',
                '1': 'На согласовании',
            },
            markAsRead: 'Пометить как прочитанное',
        },
        trainer: {
            responsible: 'Ответственный',
            course: 'Курс',
            participantsNumber: 'Кол-во участников',
            participants: 'Участники',
            missed: 'Пропустил',
            presence: 'Присутствие',
            mark: 'Оценка'
        },
        news: {
            name: 'Имя',
            date: 'Дата',
            state: 'Состояние',
            briefNews: 'Краткое содержание'
        },
        fileLibrary: {
            name: 'Имя',
            sentDate: 'Дата отправки'
        }
    }
};
